// extracted by css-extract-rspack-plugin
var _1 = "xbopcMcNYBoi8Qsh";
var _2 = "diOa62RkSVYDDLmr";
var _3 = "MohDow_qZl8al8T2";
var _4 = "o42fZo7x1sAwPGwI";
var _5 = "diOa62RkSVYDDLmr";
var _6 = "MohDow_qZl8al8T2";
var _7 = "o42fZo7x1sAwPGwI";
var _8 = "t1Yb8eyq2ts0WQuH";
var _9 = "AJzTkUOyia0ZVrHN";
var _a = "Dkw9Dbh1DXEtmaIH";
var _b = "Tlcy9tAxhUUIPAwe";
var _c = "Tlcy9tAxhUUIPAwe";
var _d = "OGumQAUQXUk8CTx_";
export { _1 as "answer", _2 as "answer-perc", _3 as "answer-text", _4 as "answer-voted", _5 as "answerPerc", _6 as "answerText", _7 as "answerVoted", _8 as "body", _9 as "poll", _a as "question", _b as "result-bar", _c as "resultBar", _d as "voted" }
